import { createReducer, on } from '@ngrx/store';
import { defaultWalletListFilter } from '../../types/wallet-list-filter';
import {
  fetchPartnerWalletList,
  loadedPartnerWalletList,
  failedPartnerWalletList,
  updatePartnerWalletListFilter,
  resetPartnerWalletList,
} from './partner-wallet-list.actions';
import {
  initialPartnerWalletListState,
  PartnerWalletListState,
  initialDataSource,
} from './partner-wallet-list.state';

export const partnerWalletListReducer = createReducer(
  initialPartnerWalletListState,
  on(fetchPartnerWalletList, (state): PartnerWalletListState => ({ ...state })),
  on(loadedPartnerWalletList, (state, action): PartnerWalletListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: action.dataSource,
    };
  }),
  on(failedPartnerWalletList, (state): PartnerWalletListState => {
    return {
      ...state,
      filter: { ...state.filter },
      dataSource: { ...initialDataSource },
    };
  }),
  on(
    updatePartnerWalletListFilter,
    (state, { filter }): PartnerWalletListState => {
      return {
        ...state,
        filter: { ...state.filter, ...(filter ?? defaultWalletListFilter) },
        dataSource: { ...state.dataSource },
      };
    }
  ),
  on(resetPartnerWalletList, (state): PartnerWalletListState => {
    return {
      ...state,
      filter: { ...defaultWalletListFilter },
      dataSource: { ...state.dataSource },
    };
  })
);
